(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-chair-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ht-chairs]').forEach(root=>{const grid=root.querySelector('[data-ht-grid]');if(!grid)return;const cards=[...grid.querySelectorAll('[data-ht-card]')];const brand=root.querySelector('[data-ht-brand]');const price=root.querySelector('[data-ht-price]');const sort=root.querySelector('[data-ht-sort]');const count=root.querySelector('[data-ht-count]');const originalCount=count.textContent;function update(){const bounds=price.value?price.value.split(':').map(Number):null;let shown=0;cards.forEach(card=>{const amount=Number(card.dataset.price);card.hidden=Boolean((brand&&brand.value&&card.dataset.brand!==brand.value)||(bounds&&(amount<bounds[0]||amount>=bounds[1])));if(!card.hidden)shown++});cards.sort((a,b)=>sort.value==='asc'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.index)-Number(b.dataset.index)).forEach(card=>grid.appendChild(card));count.textContent=originalCount.replace(/\d+/,String(shown));root.querySelector('[data-ht-empty]').hidden=shown!==0}[brand,price,sort].filter(Boolean).forEach(select=>select.addEventListener('change',update));root.querySelector('[data-ht-reset]').addEventListener('click',()=>{if(brand)brand.value='';price.value='';sort.value='default';update()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-learning-center"]) return;
  try {
    
function initializeLearning(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const cards=[...root.querySelectorAll('[data-learning-card]')];
  const controls=root.querySelector('.ht-learning__controls');
  const buttons=[...root.querySelectorAll('[data-topic-button]')];
  const search=root.querySelector('[data-learning-search]');
  const count=root.querySelector('[data-learning-count]');
  const empty=root.querySelector('[data-learning-empty]');
  const more=root.querySelector('[data-learning-more]');
  const params=new URLSearchParams(window.location.search);
  let topic=params.get('topic')||root.dataset.topic;
  if(!['all','chairs','mattresses'].includes(topic))topic='all';
  let visibleLimit=12;
  function update(){
    const term=search.value.trim().toLocaleLowerCase();
    const matching=cards.filter(card=>(topic==='all'||topic==='chairs'&&card.dataset.chair==='true'||topic==='mattresses'&&card.dataset.mattress==='true')&&card.dataset.search.includes(term));
    const shown=new Set(matching.slice(0,visibleLimit));
    cards.forEach(card=>card.hidden=!shown.has(card));
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.topicButton===topic)));
    count.textContent=count.dataset.countTemplate.replace('__COUNT__',String(matching.length));
    empty.hidden=matching.length!==0;
    more.hidden=matching.length<=visibleLimit;
    root.querySelectorAll('.ht-learning__nav a').forEach(link=>{const url=new URL(link.href);if(topic==='all')url.searchParams.delete('topic');else url.searchParams.set('topic',topic);link.href=url.pathname+url.search;});
  }
  controls.hidden=false;
  buttons.forEach(button=>button.addEventListener('click',()=>{topic=button.dataset.topicButton;visibleLimit=12;const url=new URL(window.location.href);if(topic==='all')url.searchParams.delete('topic');else url.searchParams.set('topic',topic);window.history.replaceState({},'',url);update();}));
  search.addEventListener('input',()=>{visibleLimit=12;update();});
  more.addEventListener('click',()=>{visibleLimit+=12;update();});
  update();
}
document.querySelectorAll('[data-learning]').forEach(initializeLearning);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-learning]').forEach(initializeLearning));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-mattress-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ht-mattresses]').forEach(root=>{const grid=root.querySelector('[data-ht-grid]');if(!grid)return;const cards=[...grid.querySelectorAll('[data-ht-card]')];const brand=root.querySelector('[data-ht-brand]');const price=root.querySelector('[data-ht-price]');const sort=root.querySelector('[data-ht-sort]');const count=root.querySelector('[data-ht-count]');const originalCount=count.textContent;function update(){const bounds=price.value?price.value.split(':').map(Number):null;let shown=0;cards.forEach(card=>{const amount=Number(card.dataset.price);card.hidden=Boolean((brand&&brand.value&&card.dataset.brand!==brand.value)||(bounds&&(amount<bounds[0]||amount>=bounds[1])));if(!card.hidden)shown++});cards.sort((a,b)=>sort.value==='asc'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.index)-Number(b.dataset.index)).forEach(card=>grid.appendChild(card));count.textContent=originalCount.replace(/\d+/,String(shown));root.querySelector('[data-ht-empty]').hidden=shown!==0}[brand,price,sort].filter(Boolean).forEach(select=>select.addEventListener('change',update));root.querySelector('[data-ht-reset]').addEventListener('click',()=>{if(brand)brand.value='';price.value='';sort.value='default';update()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
